import type { ModalityType } from '../types';

export const procedureColors: { [x in ModalityType]: string } = {
  // Note: These are defined in tailwind.config.js
  Lap: 'bg-lap',
  Robotic: 'bg-robotic',
  Open: 'bg-open',
  Other: 'bg-other',
};
